import type { PropsWithChildren } from "react";

import { styled } from "@linaria/react";

const StyledSpinAnimation = styled.div<{ $speed: number }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  animation: spin ${({ $speed }) => 1 / $speed}s linear infinite;
  transform-origin: 50% 50%;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export interface SpinAnimationProps {
  speed?: number;
  isEnabled?: boolean;
}

const SpinAnimation = ({
  children,
  speed = 1,
  isEnabled = true,
}: PropsWithChildren<SpinAnimationProps>) => {
  if (isEnabled) {
    return <StyledSpinAnimation $speed={speed}>{children}</StyledSpinAnimation>;
  }

  return <>{children}</>;
};

export default SpinAnimation;
